import { z } from 'zod';

const DataPoint = z.object({
    tPreArc: z.number(),
    sumI2t: z.number(),
});

export const I2tCurve = {
    validator: z.array(DataPoint).default([]),
    units: { tPreArc: 's', sumI2t: 'A²•s' } as const,
};

export type I2tCurve = z.infer<typeof I2tCurve.validator>;
